/**
 * Veigar ability params (wiki Ability data rank-1).
 * Kept separate from veigar.js to avoid entity ↔ catalog circular imports.
 */

export const VEIGAR_Q_RANGE = 1050;
export const VEIGAR_Q_SPEED = 2200;
export const VEIGAR_Q_WIDTH = 140;
export const VEIGAR_Q_RADIUS = VEIGAR_Q_WIDTH / 2;
export const VEIGAR_Q_MANA = 30;

export const VEIGAR_W_RANGE = 950;
export const VEIGAR_W_RADIUS = 240;
export const VEIGAR_W_EFFECT_DELAY_SEC = 1.221;
export const VEIGAR_W_MANA = 60;
export const VEIGAR_W_COOLDOWN = 8;

export const VEIGAR_E_RANGE = 725;
export const VEIGAR_E_EFFECT_DELAY_SEC = 0.5;
export const VEIGAR_E_DURATION_SEC = 3;
export const VEIGAR_E_INNER = 290;
export const VEIGAR_E_OUTER = 411;
export const VEIGAR_E_CC_DURATION_SEC = 1.5;
export const VEIGAR_E_MANA = 70;
export const VEIGAR_E_COOLDOWN = 20;
/** @deprecated alias — prefer VEIGAR_E_CC_DURATION_SEC */
export const VEIGAR_E_STUN_SEC = VEIGAR_E_CC_DURATION_SEC;

export const VEIGAR_R_COOLDOWN = 120;
